export default __webpack_public_path__ + "static/expo1-850fa8a9b3fcca75cc598bbf9321f5db.jpg";